import React from 'react';
import PropTypes from 'prop-types';
import {Link} from 'react-router-dom';
import {generateRoutePath} from '@epic-core/common';
import {getOptImage} from 'epic-ue-shared';

export default class CarouselItem extends React.PureComponent {
    static propTypes = {
        title: PropTypes.string,
        type: PropTypes.string,
        description: PropTypes.string,
        image: PropTypes.string,
        buttonLabel: PropTypes.string,
        buttonLink: PropTypes.string,
        bgImage: PropTypes.string,
        bgImageMobile: PropTypes.string,
        bgColor: PropTypes.string,
        mobile: PropTypes.bool
    };

    render() {
        const {
            title,
            type,
            description,
            image,
            buttonLabel,
            buttonLink,
            bgImage,
            bgImageMobile,
            bgColor,
            mobile
        } = this.props;

        let button;
        if (buttonLink && buttonLabel) {
            let external = false;
            if (buttonLink && buttonLink.indexOf('http') === 0) {
                external = true;
            }

            if (external) {
                button = (
                    <a href={buttonLink} className="btn-lg btn">
                        {buttonLabel}
                    </a>
                );
            } else {
                button = (
                    <Link className="btn-lg btn" to={generateRoutePath(buttonLink)}>
                        {buttonLabel}
                    </Link>
                );
            }
        }

        const img = getOptImage({
            url: mobile && bgImageMobile ? bgImageMobile : bgImage,
            width: 1200
        });

        return (
            <div className="slide">
                <div className="image-container" style={{backgroundImage: `url(${img})`}}>
                    &nbsp;
                </div>
                <div
                    className="content"
                    style={{backgroundColor: `${!bgColor ? '#141b24' : bgColor}`}}>
                    <div className="tag">{type}</div>
                    <div className="title">{title}</div>
                    <div className="desc" dangerouslySetInnerHTML={{__html: description}} />
                    {image !== undefined ? (
                        <div className="avatar">
                            <img src={getOptImage({url: image, width: 600})} alt={title} />
                        </div>
                    ) : (
                        ''
                    )}

                    <div className="button-bar">{button}</div>
                </div>
            </div>
        );
    }
}
